export default __webpack_public_path__ + "img/0d15af9261b4851bc05620d1cb6db560.svg";